@if(!user()!.userImg){
	<app-initials-avatar [firstName]="user().firstName" [lastName]="user().lastName"/>
}
@else {
		<img class="user-avatar__image" [src]="user()!.userImg" alt="Profilbild"/>
}